const searchCN = {
    SEARCH_01:'未找到联系人相关结果',
    SEARCH_02:'查询该公司其他',
    SEARCH_03:'关键联系人。',
    SEARCH_04:'余额不足，请充值',
    SEARCH_05:'取 消',
    SEARCH_06:'去充值',
    SEARCH_07:'登录后可使用该功能',
    SEARCH_08:'返回',
    SEARCH_09:'没有找到相关公司',
    SEARCH_10:'不限',
    SEARCH_11:'请输入英文公司名或产品关键词',
    SEARCH_12:'请输入关键词',
    SEARCH_13:'换个关键词或扩大范围试试?',
    SEARCH_14:'加载更多',
    SEARCH_15:'请选择联系人',
    SEARCH_16:'采购金额',
    SEARCH_17:'采购次数',
    SEARCH_18:'供应商数量',
    SEARCH_19:'1月',
    SEARCH_20:'2月',
    SEARCH_21:'3月',
    SEARCH_22:'4月',
    SEARCH_23:'5月',
    SEARCH_24:'6月',
    SEARCH_25:'7月',
    SEARCH_26:'8月',
    SEARCH_27:'9月',
    SEARCH_28:'10月',
    SEARCH_29:'11月',
    SEARCH_30:'12月',
    SEARCH_31:'采购金额（美元）',
    SEARCH_32:'没有更多了',
    SEARCH_33:'数据已完善',
    SEARCH_34:'已添加',
    SEARCH_35:'公司新闻',
    SEARCH_36:'来源',
    SEARCH_37:'发布时间',
    SEARCH_38:'查看更多新闻',
    SEARCH_39:'推文',
    SEARCH_40:'关注',
    SEARCH_41:'粉丝',
    SEARCH_42:'影响力',
    SEARCH_44:'交易时间段',
    SEARCH_45:'至',
    SEARCH_46:'交易金额',
    SEARCH_47:'美元',
    SEARCH_48:'交易次数',
    SEARCH_49:'次（平均每月采购次数：',
    SEARCH_50:'次）',
    SEARCH_51:'平均单价',
    SEARCH_52:'采购商编码',
    SEARCH_53:'采购产品分析',
    SEARCH_54:'期间采购产品共计',
    SEARCH_55:'类',
    SEARCH_56:'了解其采购产品种类，判断买家专业匹配度，向买家提供其他产品。',
    SEARCH_57:'产品描述',
    SEARCH_58:'产品编码',
    SEARCH_59:'交易金额（美元）',
    SEARCH_60:'采购行为分析',
    SEARCH_61:'供应商明细',
    SEARCH_62:'期间供应商共计',
    SEARCH_63:'个',
    SEARCH_64:'了解全球供应链，利于了解合作深度，利于拟定服务策略。',
    SEARCH_65:'供应商名称',
    SEARCH_66:'交易总量(KG)',
    SEARCH_67:'交易份额',
    SEARCH_68:'采购记录明细',
    SEARCH_69:'期间共计采购',
    SEARCH_70:'次',
    SEARCH_71:'了解买家采购明细，掌握产品交易价格，知己知彼事半功倍。',
    SEARCH_72:'到港时间',
    SEARCH_73:'供应商名称',
    SEARCH_74:'原产国',
    SEARCH_75:'商品编码',
    SEARCH_76:'本次查看不扣额度',
    SEARCH_77:'请输入人名进行搜索',
    SEARCH_78:'未找到该联系人，请调整姓名试试',
    SEARCH_79:'未找到该公司联系人，请调整公司名试试',
    SEARCH_80:'公司搜索',
    SEARCH_81:'联系人搜索',
    OVER_TIMES_TO_PAY:'本月额度已使用完毕，余额不足！请充值。',

    SEARCH_82:'请输入公司名进行搜索',
    SEARCH_83:'请输入人名进行搜索',
    SEARCH_84:'*试试两个搜索框同时输入词条，让结果更精准'

}
export default searchCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_search.js